import { ataNettoTotal } from '../../utils/calculations'
import type { ATAView, CombinedEntry, Surcharge } from './types'

/** Convert a combined entry + surcharges into a design-model ÄTA view object. */
export function entryToATA(entry: CombinedEntry, surcharges: Surcharge[] = []): ATAView {
  const { sortOrder, journal, notification, ataSpec } = entry
  const belopp = ataSpec ? ataNettoTotal(ataSpec.lineItems ?? [], surcharges) : null
  return {
    sortOrder,
    nr: sortOrder,
    rubrik: journal?.arbeteBeskrivning ?? '',
    beskrivning: journal?.arbeteDetaljer ?? '',
    status: journal?.status ?? 'upplagd',
    orsak: journal?.orsak ?? '',
    paverkanTid: journal?.paverkanTid ?? '',
    paverkanEkonomi: journal?.paverkanEkonomi ?? '',
    ansvarig: journal?.ansvarig ?? '',
    skapad: journal?.skapad ?? null,
    senastUppdaterad: journal?.senastUppdaterad ?? null,
    anmald: notification?.datum ?? null,
    harUnderrattelse: !!notification,
    harSpec: !!ataSpec,
    belopp,
    antalRader: ataSpec?.lineItems?.length ?? 0,
    bestallarSvar: notification?.bestellarSvar ?? '–',
    journal,
    notification,
    ataSpec,
  }
}
